import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const SaveJamesVision = () => {
  return (
    <div id="vision" className="container-fluid py-5 bg-dark text-white">
      <Container>
        {/* Vision Title and Intro */}
        <Row className="text-center mb-5">
          <Col>
            <h2 className="fw-bold text-white">
              Empowering Change, Securing the Future
            </h2>
            <p className="lead">
              At <strong>$SAVEJAMES</strong>, our vision is to create a world
              where activism and innovation intersect, using the transformative
              power of cryptocurrency to protect children and safeguard their
              futures.
            </p>
          </Col>
        </Row>

        {/* Commitment to Integrity Card */}
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={8}>
            <Card className="shadow-lg border-dark">
              <Card.Body>
                <Card.Title className="fw-bold text-dark text-center mb-3">
                  A Commitment to Integrity
                </Card.Title>
                <Card.Text className="text-muted">
                  <ul>
                    <li>
                      <strong>Jeff Younger</strong>, the largest coin holder and
                      voice of the movement, has locked his $SAVEJAMES holdings
                      to protect the mission and secure the coin’s future.
                    </li>
                    <li>
                      Large holders have pledged coins to liquidity pools,
                      ensuring smooth operations and enhancing transaction flow.
                    </li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Roadmap Card */}
        <Row className="justify-content-center mb-5">
          <Col md={10} lg={8}>
            <Card className="shadow-lg border-dark">
              <Card.Body>
                <Card.Title className="fw-bold text-dark text-center mb-3">
                  Our Roadmap
                </Card.Title>
                <Card.Text className="text-muted">
                  <ol>
                    <li>
                      <strong>Global Awareness Campaigns:</strong> Use the
                      $SAVEJAMES platform to fund grassroots efforts and shine a
                      light on injustice.
                    </li>
                    <li>
                      <strong>Innovative Partnerships:</strong> Collaborate with
                      like-minded organizations and influencers.
                    </li>
                    <li>
                      <strong>Community-Driven Growth:</strong> Reward holders
                      who actively spread the cause and contribute to liquidity.
                    </li>
                  </ol>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Closing Message */}
        <Row className="text-center mb-5">
          <Col>
            <p className="lead">
              <strong>$SAVEJAMES</strong> is more than a coin—it’s a movement.
              Together, we prove that the cryptocurrency revolution can drive
              meaningful societal change.
            </p>
          </Col>
        </Row>

        {/* Vision Explanation */}
        <Row>
          <Col>
            <p className="text-center ">
              A World Where Everyone Wins: In the <strong>$SAVEJAMES</strong>{" "}
              ecosystem, financial growth and moral action go hand in hand. The
              more the movement grows, the more its coin increases in value—and
              the closer we come to ending harmful practices against children.
              It's a vision of doing well by doing good, where every holder is
              part of a transformative mission. Join us as we redefine the
              possibilities of cryptocurrency. Together, we'll create a movement
              that secures futures, protects the vulnerable, and builds a better
              world for generations to come. <strong>$SAVEJAMES</strong>: More
              than a coin—it’s a legacy.
            </p>
          </Col>
        </Row>

        {/* Call to Action Button */}
        <Row className="text-center mt-4">
          <Col>
            <Button
              variant="primary"
              href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
              target="_blank"
              size="lg"
            >
              Join the Movement
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SaveJamesVision;
